/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamMutationRequest,
  PostApiV1ExamMutationResponse,
  PostApiV1Exam400,
  PostApiV1Exam401,
  PostApiV1Exam500,
} from "../../types/examEvaluationController/PostApiV1Exam.ts";

function getPostApiV1ExamUrl() {
  const res = { method: "POST", url: `/api/v1/exam` as const };
  return res;
}

/**
 * @description Cria uma nova prova com os dados fornecidos. Quando o tipo de prova é Challenge, os valores de ExamReferenceShow e ExamReferenceShowPost são forçados para Partial, independente do valor enviado. **(Requer Authorization para autenticação)**
 * @summary Criar prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam}
 */
export async function postApiV1Exam(
  data?: PostApiV1ExamMutationRequest,
  config: Partial<RequestConfig<PostApiV1ExamMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ExamMutationResponse,
    ResponseErrorConfig<PostApiV1Exam400 | PostApiV1Exam401 | PostApiV1Exam500>,
    PostApiV1ExamMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ExamUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
